import React from "react";
import {Box, Center, Divider, Loader, Title} from "@mantine/core";

export function DividerTitle(props: {title: string, order: any, t_id: string, position?: "left" | "center" | "right", variant?: "solid" | "dashed" | "dotted" | "double" | "groove" | "ridge" | "inset" | "outset"}) {

    return (
        <div className="divider-title">
            <Box h={8}/>
                <Divider label={<Title order={props.order} id={props.t_id}>{props.title}</Title>} labelPosition={props.position} variant={props.variant} />
            <Box h={8}/>
        </div>
    );
}

export function MyLoader() {
    return (
        <Box>
            <Center h={window.innerHeight - 200}>
                <Loader color="blue" variant="oval" />
            </Center>
        </Box>
    );
}

